var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8666",
    "data-name": "Group 8666",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    "data-name": "Path 3354",
    d: "M9.084,16.167a7.084,7.084,0,1,1,7.084-7.084A7.084,7.084,0,0,1,9.084,16.167Zm0-1.417A5.667,5.667,0,1,0,3.417,9.084,5.667,5.667,0,0,0,9.084,14.751Zm-.708-3.542H9.792v1.417H8.375Zm1.417-1.165V10.5H8.375V9.438a.708.708,0,0,1,.708-.708A1.063,1.063,0,1,0,8.042,7.459L6.652,7.18a2.48,2.48,0,1,1,3.14,2.863Z",
    transform: "translate(-0.583 -0.583)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.54afbcec69fd6f6ac4dda2eaf10daa4a.svg";
export { ForwardRef as ReactComponent };